import axios from 'axios';
import { generateHttpActions } from '../../../../../utility';

function getChatJourneyStatusHttpRequest() {
  const functionName = 'journeyStatus';

  const httpActions = generateHttpActions(functionName);
  const resource = `genai-assistant/first-time-journey/status`;

  return async (dispatch) => {
    dispatch(httpActions.start());
    try {
      const response = await axios.get(resource, {});
      dispatch(httpActions.success(response.data));
    } catch (error) {
      dispatch(httpActions.error(error));
    }
  };
}

export default getChatJourneyStatusHttpRequest;
